import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal } from '@mui/material';
import TransportationModal from './transportationModal';

export const SeatModal = ({
  handleCloseSeatModal,
  openSeatModal,
  transportationEventFormData,
}) => {
  return (
    <Modal
      open={openSeatModal}
      onClose={handleCloseSeatModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        style={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1050,
          height: '90%',
          backgroundColor: 'white',
          boxShadow: 24,
          padding: 10,
          overflowY: 'scroll',
        }}
      >
        <div className="flex justify-end items-end py-2 px-1">
          <IconButton component="span" onClick={handleCloseSeatModal}>
            <Close />
          </IconButton>
        </div>

        <div className="flex flex-col justify-center items-center">
          <TransportationModal
            transportationId={transportationEventFormData?.id}
          />
        </div>
      </Box>
    </Modal>
  );
};
